'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxForm = require('redux-form');
var _lodash = require('lodash');
var _reactRouter = require('react-router');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _FeedbackIncreaseLimits = require('./FeedbackIncreaseLimits.scss');var styles = _interopRequireWildcard(_FeedbackIncreaseLimits);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

FeedbackIncreaseLimits = function (_Component) {_inherits(FeedbackIncreaseLimits, _Component);function FeedbackIncreaseLimits() {var _temp, _this, _ret;_classCallCheck(this, FeedbackIncreaseLimits);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.







































    мessageModalOk = function () {
      _this.props.closeModal();
      _this.props.hideMessageModal();
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign'));
    }, _this.

    submitForm = function (value) {
      _this.props.askForeignLimit({ data: value, token: _this.props.userToken });
    }, _this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.submitForm)(evt);
      return true;
    }, _this.

    renderInput = function (input, meta, placeholder, disabled) {return (
        _react2.default.createElement('input', _extends({},
        input, {
          type: 'text',
          disabled: disabled,
          placeholder: _this.props.translate('modalForeignLimit', placeholder),
          className: (0, _classnames2.default)(styles.inputNumb, styles.numeric, 'form-control',
          { not_valid: meta.touched && meta.error && !meta.active }) })));}, _this.



    renderNameInput = function (_ref) {var input = _ref.input,meta = _ref.meta;return (
        _this.renderInput(Object.assign({}, input), meta, 'name', (0, _lodash.get)(_this.props, 'userData.display_name', false)));}, _this.
    renderEmailInput = function (_ref2) {var input = _ref2.input,meta = _ref2.meta;return (
        _this.renderInput(Object.assign({}, input), meta, 'email', (0, _lodash.get)(_this.props, 'userData.email', false)));}, _this.
    renderPhoneNumberInput = function (_ref3) {var input = _ref3.input,meta = _ref3.meta;return _this.renderInput(Object.assign({}, input), meta, 'phoneNumber');}, _this.
    renderMessageInput = function (_ref4) {var input = _ref4.input,meta = _ref4.meta;return _this.renderInput(Object.assign({}, input), meta, 'message');}, _this.

    renderForm = function () {return (
        _react2.default.createElement('div', { className: styles.formWrapper },
          _react2.default.createElement('div', { className: styles.formRow },
            _react2.default.createElement('span', { className: styles.label },
              _this.props.translate('modalForeignLimit', 'name'),
              _react2.default.createElement('span', { className: 'req' }, '*')),

            _react2.default.createElement('div', { className: styles.content },
              _react2.default.createElement(_reduxForm.Field, {
                name: 'name',
                locale: _this.props.locale,
                component: _this.renderNameInput }))),



          _react2.default.createElement('div', { className: styles.block },
            _react2.default.createElement('div', { className: styles.formRow },
              _react2.default.createElement('span', { className: styles.label },
                _this.props.translate('modalForeignLimit', 'phoneNumber'),
                _react2.default.createElement('span', { className: 'req' }, '*')),

              _react2.default.createElement('div', { className: styles.content },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'phone_number',
                  locale: _this.props.locale,
                  component: _this.renderPhoneNumberInput }))),



            _react2.default.createElement('div', { className: styles.formRow },
              _react2.default.createElement('span', { className: styles.label },
                _this.props.translate('modalForeignLimit', 'email'),
                _react2.default.createElement('span', { className: 'req' }, '*')),

              _react2.default.createElement('div', { className: styles.content },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'email',
                  locale: _this.props.locale,
                  component: _this.renderEmailInput })))),




          _react2.default.createElement('div', { className: styles.formRow },
            _react2.default.createElement('span', { className: styles.label },
              _this.props.translate('modalForeignLimit', 'message'),
              _react2.default.createElement('span', { className: 'req' }, '*')),

            _react2.default.createElement('div', { className: styles.content },
              _react2.default.createElement(_reduxForm.Field, {
                name: 'message',
                locale: _this.props.locale,
                component: _this.renderMessageInput })))));}, _temp), _possibleConstructorReturn(_this, _ret);}FeedbackIncreaseLimits.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref5) {var foreignLimit = _ref5.foreignLimit;if (foreignLimit.loaded && foreignLimit.loaded !== this.props.foreignLimit.loaded) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, this.props.translate('modalForeignLimit', 'messageSent')), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.мessageModalOk }, this.props.translate('contactUsPage', 'ok')))), isCloseButtonInvisible: true });}if (foreignLimit.error && foreignLimit.error !== this.props.foreignLimit.error) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, this.props.translate('modalForeignLimit', 'errorMessage')), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.props.hideMessageModal }, this.props.translate('contactUsPage', 'ok')))) });}};FeedbackIncreaseLimits.prototype.






  render = function render() {var _props =






    this.props,closeModal = _props.closeModal,foreignLimit = _props.foreignLimit,translate = _props.translate,isPackageUpdate = _props.isPackageUpdate,withoutSubtitle = _props.withoutSubtitle;
    var isPublishForeign = (0, _lodash.get)(this.props, 'userData.publish_permissions.foreign', null);

    return (
      _react2.default.createElement('div', { className: styles.container },
        _react2.default.createElement('span', {
            className: styles.close,
            onClick: closeModal },

          _react2.default.createElement('i', { className: 'icon icon-close' })),

        _react2.default.createElement('p', { className: styles.title },
          !isPackageUpdate ?
          translate('modalForeignLimit', isPublishForeign ? 'title' : 'regularTitle') :
          translate('modalForeignLimit', 'packageUpdateTitle')),


        !withoutSubtitle &&
        _react2.default.createElement('p', { className: styles.subtitle },
          isPublishForeign ?
          translate('modalForeignLimit', 'subtitle') :
          translate('modalForeignLimit', 'regularSubtitle')),



        _react2.default.createElement('form', null,
          this.renderForm()),

        _react2.default.createElement('div', { className: styles.submitWrapper },
          _react2.default.createElement('button', {
              onClick: this.handleSubmit,
              disabled: foreignLimit.loading },

            foreignLimit.loading ?
            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', 'spinner') }) :
            _react2.default.createElement('span', { className: 'button-text' }, translate('modalForeignLimit', 'send'))))));





  };return FeedbackIncreaseLimits;}(_react.Component);


FeedbackIncreaseLimits.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  isPackageUpdate: _propTypes2.default.bool,
  reset: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  closeModal: _propTypes2.default.func,
  askForeignLimit: _propTypes2.default.func,
  foreignLimit: _propTypes2.default.object,
  userToken: _propTypes2.default.string,
  fields: _propTypes2.default.object,
  withoutSubtitle: _propTypes2.default.bool };exports.default =


FeedbackIncreaseLimits;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FeedbackIncreaseLimits/FeedbackIncreaseLimits.js
// module id = 2669
// module chunks = 0